import { t, Instance } from 'mobx-state-tree';
import { RELATIONSHIP_TYPE_VALUES } from '../../types';

export const RelationshipModel = t
  .model('RelationshipModel', {
    id: t.identifier,
    familyMember1Id: t.string, // familyMember1 is the parent/guardian/owner/ or spouse1
    familyMember2Id: t.string, // familyMember2 is the child/dependent/pet/ or spouse2
    relationshipType: t.enumeration('relationshipType', RELATIONSHIP_TYPE_VALUES),
    notes: t.maybeNull(t.string),
    startDate: t.maybeNull(t.string),
    endDate: t.maybeNull(t.string)
  })
  .views((self) => ({
    get isMarriage(): boolean {
      return self.relationshipType === 'spousal';
    },
    get isParentChild(): boolean {
      // All non-spousal relationship types are parent-like (biological, adoptive, foster, step, guardian)
      return self.relationshipType !== 'spousal';
    },
    get duration(): number | null {
      if (!self.startDate) return null;
      const start = new Date(self.startDate);
      const end = self.endDate ? new Date(self.endDate) : new Date();
      return Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
    }
  }))
  .actions((self) => ({
    setRelationshipType(relationshipType: typeof self.relationshipType) {
      self.relationshipType = relationshipType;
    },
    setNotes(notes: string | null) {
      self.notes = notes;
    },
    setStartDate(startDate: string | null) {
      self.startDate = startDate;
    },
    setEndDate(endDate: string | null) {
      self.endDate = endDate;
    },
    endRelationship() {
      if (!self.endDate) {
        self.endDate = new Date().toISOString();
      }
    }
  }));

export type RelationshipType = Instance<typeof RelationshipModel>;
